/**
 * UI-6b Task 11 — ChannelMix widget manifest.
 *
 * Phase 1 PLACEHOLDER — see Renderer.tsx. The manifest registers the
 * widget in the library so admins can place it on a dashboard; once
 * UI-6d ships `groupBy=channel`, only Renderer.tsx needs to change.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import { ChannelMixRenderer, type ChannelMixConfig } from './Renderer.js'
import { ChannelMixConfigEditor } from './ConfigEditor.js'

export const channelMixManifest: WidgetManifest<ChannelMixConfig> = {
  type: 'channel-mix',
  label: 'Channel Mix',
  description: 'Breakdown of conversations by channel (Phase 1: placeholder).',
  defaultSize: '1x1',
  defaultConfig: {} as ChannelMixConfig,
  Renderer: ChannelMixRenderer,
  ConfigEditor: ChannelMixConfigEditor,
}

registerWidget(channelMixManifest)
